import { render, staticRenderFns } from "./ShowTotal.vue?vue&type=template&id=4adc4055&"
import script from "./ShowTotal.vue?vue&type=script&lang=js&"
export * from "./ShowTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports